/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import t from "../../../trans";

class NavbarLogin extends React.Component {
    static propTypes = {
        onLogout: PropTypes.func
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};

        this.onClickLogout = this.onClickLogout.bind(this);
    }

    onClickLogout(e) {
        e.preventDefault();
        if (this.props.onLogout) this.props.onLogout();
    }

    render() {
        return (
            <li>
                <a href="#" onClick={this.onClickLogout}>
                    <i className="fa fa-sign-out"/> {t("Log out")}
                </a>
            </li>
        );
    }
}

export default NavbarLogin;
